import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import FiltersAndGrid from "./FiltersAndGrid";
import { Divider, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import SaitRowAction from "../columns/SaitRowAction";
import SimpleGrid from "./SimpleGrid";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import { useTranslation } from "react-i18next";
import { saitfecoreNs } from "../utils/Constants";

export default function TransferGrids(props) {
	const [clientControlledFilter, setClientControlledFilter] = React.useState(false);

	const { t } = useTranslation(saitfecoreNs);

	const [leftSelections, setLeftSelections] = React.useState([]);
	const [rightSelections, setRightSelections] = React.useState([]);

	const [leftRows, setLeftRows] = React.useState(null);

	const [startRightRows, setStartRightRows] = React.useState(null);

	const promisedSetRightRows = (newRight) => new Promise((resolve) => props.setRightRows(newRight));

	const promisedSetLeftRows = (setLeft, newLeft) => new Promise((resolve) => setLeft(newLeft));

	useEffect(() => {
		if (leftRows !== null) {
			setClientControlledFilter(true);
		}
		// eslint-disable-next-line
	}, [leftRows]);

	useEffect(() => {
		if (props.rightRows !== null) {
			if (leftRows !== null) {
				setClientControlledFilter(true);
			}
			if (startRightRows === null) {
				setStartRightRows([...props?.rightRows]);
			} else {
				if (props.setAddedElements) {
					let added = props.rightRows?.filter((newValue) => !startRightRows.some((startingValue) => props.compareFunction(newValue, startingValue)));
					props.setAddedElements(added);
				}
				if (props.setRemovedElements) {
					let removed = startRightRows.filter((startingValue) => !props.rightRows.some((newValue) => props.compareFunction(startingValue, newValue)));
					props.setRemovedElements(removed);
				}
			}
		}
		// eslint-disable-next-line
	}, [props.rightRows]);

	useEffect(() => {
		if (startRightRows !== null) {
			if (props.setAddedElements) {
				let added = props.rightRows?.filter((newValue) => !startRightRows.some((startingValue) => props.compareFunction(newValue, startingValue)));
				props.setAddedElements(added);
			}
			if (props.setRemovedElements) {
				let removed = startRightRows.filter((startingValue) => !props.rightRows.some((newValue) => props.compareFunction(startingValue, newValue)));
				props.setRemovedElements(removed);
			}
		}
		// eslint-disable-next-line
	}, [startRightRows]);

	props.leftGridParams.selection = {
		selectionFunction: (selectedRow) => {
			if (selectedRow) {
				setLeftSelections(selectedRow);
			} else {
				setLeftSelections([]);
			}
		},
		multipleSelection: true,
	};

	props.leftGridParams.columns.push(
		SaitRowAction({
			id: "AddToRightRowAction",
			icon: <KeyboardArrowRightIcon color="success" />,
			tooltip: t("add"),
			onClick: async (params) => {
				await addElementsToRight([params.row]);
			},
		}),
	);

	props.rightGridParams.selection = {
		selectionFunction: (selectedRow) => {
			if (selectedRow) {
				setRightSelections(selectedRow);
			} else {
				setRightSelections([]);
			}
		},
		multipleSelection: props.removeFromRightHidden === true ? false : true,
	};

	if (props.removeFromRightHidden !== true) {
		props.rightGridParams.columns.push(
			SaitRowAction({
				id: "RemoveFromRightRowAction",
				icon: <KeyboardArrowLeftIcon color="error" />,
				tooltip: t("remove"),
				onClick: async (params) => {
					await removeElementsFromRight([params.row]);
				},
			}),
		);
	}

	const topButtonsLeftGrid = [
		{
			text: t("add_selected"),
			icon: <KeyboardDoubleArrowRightIcon />,
			variant: "text",
			disabled: leftSelections.length === 0,
			function: async () => {
				await addElementsToRight(leftSelections);
			},
		},
	];

	const topButtonsRightGrid = [
		{
			text: t("remove_selected"),
			icon: <KeyboardDoubleArrowLeftIcon />,
			variant: "text",
			disabled: rightSelections.length === 0,
			function: async () => {
				await removeElementsFromRight(rightSelections);
			},
			hidden: props.removeFromRightHidden === true ? true : false,
		},
	];

	const addElementsToRight = async (toAddArray) => {
		let newRight = [...props.rightRows];
		newRight = [...newRight, ...toAddArray];
		await promisedSetRightRows(newRight);
	};

	const removeElementsFromRight = async (toRemoveArray) => {
		let newRight = [...props.rightRows];
		let toRemoveArrayID = toRemoveArray.map((el) => el.id);
		newRight = newRight.filter((el) => !toRemoveArrayID.includes(el.id));
		await promisedSetRightRows(newRight);
	};

	const handleElementsFromLeft = async (setLeftGridRows) => {
		if (leftRows !== null) {
			let filtered = leftRows.filter(function (leftEl) {
				// Verifica se c'è un oggetto con gli stessi valori nel secondo array
				return (
					props.rightRows?.findIndex(function (rightEl) {
						return props.compareFunction(leftEl, rightEl);
					}) === -1
				);
			});
			await promisedSetLeftRows(setLeftGridRows, filtered);
		}
	};

	return (
		<Grid container sx={{ flexGrow: 1, mb: 2 }}>
			<Grid sx={{ display: "flex" }} size={7}>
				<FiltersAndGrid
					height={props.height}
					filters={props.leftFilters}
					gridParams={props.leftGridParams}
					topButtons={topButtonsLeftGrid}
					clientControlledFilter={clientControlledFilter}
					setClientControlledFilter={setClientControlledFilter}
					autoload
					inLineButtonFilter
					setExternalRows={setLeftRows}
					clientSideFiltering={handleElementsFromLeft}
					sortingMode="client"
					paginationMode="client"
					noStandardToolbar
				/>
				<Divider
					orientation="vertical"
					flexItem
					sx={{
						m: 2,
					}}
				/>
			</Grid>
			<Grid sx={{ display: "flex", flexDirection: "column" }} size={5}>
				<Box
					height={45}
					sx={{
						justifyContent: "center",
						display: "flex",
						flexDirection: "column",
					}}
				>
					<Typography
						sx={{
							fontWeight: "bold",
							fontSize: 15,
						}}
						textAlign="center"
					>
						{props.rightLabel}
					</Typography>
				</Box>
				<SimpleGrid
					rows={props.rightRows || []}
					gridParams={props.rightGridParams}
					topButtons={topButtonsRightGrid}
					isFiltering={props.rightRows === null}
					noStandardToolbar
					rowBackgroundColor={props.rightGridRowBackgroundColor || null}
				/>
			</Grid>
		</Grid>
	);
}
